export default __webpack_public_path__ + "static/media/Chris_Inman.617890f3.png";